import Vue from 'vue';
import App from './App.vue';

/* eslint-disable no-new */
Vue.config.devtools = true;
new Vue({
  el: 'body',
  components: { App },
});



/** WEBPACK FOOTER **
 ** ./src/main.js
 **/